import * as React from 'react';
import { Redirect } from 'react-router';

interface Props {
  refreshToken: string;
  children: any;
}

const auth = (props: Props) => {
  return props.refreshToken === '' ? (
    <Redirect to={'/allowcalendaraccess'} />
  ) : (
    props.children
  );
};

export default auth;



// WEBPACK FOOTER //
// ./src/components/Auth.tsx